import {
  ActionType,
  CertificatesParams,
  ITransferCertificateData,
  ScanGeolocationPayload,
} from './model'

import { CerteficateSettingsProps, MetaData, PreviewPublicCertificateProps } from 'types'

import { ActionCallback, ActionTypeOnly, IValidationCallback } from '../model'

export const getTabsSummary = (payload: { query: string | null }, callback?: () => void): ActionCallback => ({
  type: ActionType.GET_TABSSUMMARY,
  payload,
  callback,
})

export const transferCertificate = (
  payload: ITransferCertificateData,
  callback: IValidationCallback
): ActionCallback<ITransferCertificateData, IValidationCallback> => ({
  type: ActionType.TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const confirmTransferCertificate = (
  payload: { certificateId: string },
  callback: IValidationCallback
): ActionCallback<{ certificateId: string }> => ({
  type: ActionType.CONFIRM_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const cancelTransferCertificate = (
  payload: { certificateId: string },
  callback: IValidationCallback
): ActionCallback<{ certificateId: string }> => ({
  type: ActionType.CANCEL_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const requestCancelTransferCertificate = (
  payload: { certificateId: string },
  callback: IValidationCallback
): ActionCallback<{ certificateId: string }> => ({
  type: ActionType.REQUEST_CANCEL_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const confirmCancelRequestTransferCertificate = (
  payload: { certificateId: string },
  callback: IValidationCallback
): ActionCallback<{ certificateId: string }> => ({
  type: ActionType.CONFIRM_CANCEL_REQUEST_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const rejectCancelRequestTransferCertificate = (
  payload: { certificateId: string },
  callback: IValidationCallback
): ActionCallback<{ certificateId: string }> => ({
  type: ActionType.REJECT_CANCEL_REQUEST_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const editTransferMetadata = (
  payload: { transferId: string; metadata?: MetaData },
  callback: IValidationCallback
): ActionCallback<{ transferId: string; metadata?: MetaData }> => ({
  type: ActionType.EDIT_TRANSFER_METADATA,
  payload,
  callback,
})

export const previewPublicCertificate = (
  payload: PreviewPublicCertificateProps | null,
  callback?: IValidationCallback
): ActionCallback<PreviewPublicCertificateProps | null> => ({
  type: ActionType.PREVIEW_PUBLIC_CERTIFICATE,
  payload,
  callback,
})

export const editCertificateSettings = (
  payload: { certificateId: string; data: CerteficateSettingsProps },
  callback?: IValidationCallback
): ActionCallback<{ certificateId: string; data: CerteficateSettingsProps }> => ({
  type: ActionType.EDIT_CERTIFICATE_SETTINGS,
  payload,
  callback,
})

export const scanGeolocation = (payload: ScanGeolocationPayload, callback?: () => void): ActionCallback => ({
  type: ActionType.SCAN_GEOLOCATION,
  payload,
  callback,
})

export const changeCertificateStatusByCustomer = (
  payload: { certificateId: string; status: 'lost' | 'stolen' | 'active'; reason?: string },
  callback?: IValidationCallback
): ActionCallback<{ certificateId: string; status: 'lost' | 'stolen' | 'active'; reason?: string }> => ({
  type: ActionType.CHANGE_CERTIFICATE_STATUS_BY_CUSTOMER,
  payload,
  callback,
})
